module.exports = __webpack_public_path__ + "img/logo-dark.7246d49e.png";